var moneyFormat = window.price.money_format || '${{amount}}';

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function setGalleryScroll(gallery, slider) {
  if (!gallery && !slider) return;

  const slides = slider.querySelectorAll("img");
  const dots = gallery.querySelectorAll(".set-selector__slider-dot");
  const sliderRect = slider.getBoundingClientRect();
  let minDiff = Infinity;
  let activeIndex = 0;

  slides.forEach((slide, i) => {
    const diff = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
    if (diff < minDiff) {
      minDiff = diff;
      activeIndex = i;
    }
  });

  dots.forEach(dot => dot.classList.remove("active"));

  if (dots[activeIndex]) {
    dots[activeIndex].classList.add("active");
  }
}

document.addEventListener('DOMContentLoaded', () => {
  class SetSelector {
    constructor() {
      this.container = document.getElementById("setSelector");
      if (!this.container) return;
      this.wrapper = this.container.closest(".product-info");
      if (!this.wrapper) return;

      this.modalTriggers = this.wrapper.querySelectorAll('[data-modal-id]');
      this.modals = this.wrapper.querySelectorAll('.set-selector__modal');
      this.closeButtons = this.wrapper.querySelectorAll('[data-modal-close]');
      this.productPickers = this.wrapper.querySelectorAll('.set-selector__item');
      this.modalProducts = this.wrapper.querySelectorAll('.set-selector__modal-items > button:not([data-size-modal]):not([data-modal-close-size])');
      this.addToCartButton = this.wrapper.querySelector('[data-add-to-cart]');
      this.chooseDesign = this.wrapper.querySelector('[data-choose-design]');
      this.designCountText = this.wrapper.querySelector('[data-design-count]');
      this.addToCartText = this.wrapper.querySelector('[data-add-to-cart-text]');
      this.totalPriceEl = this.wrapper.querySelector('[data-total-price]');
      this.savePriceEl = this.wrapper.querySelector('[data-save-price]');
      this.backdropEl = this.wrapper.querySelector("[data-modal-backdrop]");
      this.openModals = false;
      this.selectedProducts = [null, null, null];
      this.activeSlot = null;
      this.totalPrice = [0, 0];
      this.savePrice = 0;

      this.bindEvents();
      this.handleEditParameters();
    }

    async loadAllProducts(modalId) {
      let page = 1;
      const modal = document.getElementById(modalId);

      if (modal && !modal.classList.contains("loaded")) {
        const collectionHandle = modal.getAttribute("data-collection-handle");
        const collectionType = modalId.includes("free") ? "free" : "paid";
        const container = modal.querySelector("[data-load-more-target-container]");
        const mainProductHandle = modal.getAttribute("data-main-product-handle");
        const filterContainer = modal.querySelector("[data-filters]");

        try {
          container.innerHTML = window.locales.loading;
          const response = await fetch(`/collections/${collectionHandle}/products.json?page=${page}&limit=250`);
          const data = await response.json();
          const products = data?.products?.filter(p => 
            p.handle !== mainProductHandle && 
            !window.excludeHandles.includes(p.handle) &&
            !p.tags?.some(tag => window.excludedTags.includes(tag))
          );
          
          container.innerHTML = "";

          if (products && products.length > 0) {
            products.forEach(product => {
              const productElement = this.createProductElement(product, collectionType);
              container.insertAdjacentHTML('beforeend', productElement);
            });

            this.updateFilters(data.products, filterContainer);

            if (data.products.length === 50) {
              await this.loadAllProducts(collectionHandle, page + 1);
            }
          }

          modal.classList.add("loaded");
        } catch (error) {
          console.error('Error loading products:', error);
        }
      }
    }

    updateFilters(products, filterContainer) {
      const filters = new Set([...products.map(product => product.product_type ? product.product_type : null).filter(i => i !== null)]) 

      filterContainer.innerHTML = "";
      
      filters.forEach(filter => {
        const filterButton = this.createFilterButton(filter);
        filterContainer.insertAdjacentHTML("beforeend", filterButton);
      })
    }

    isCombinationAvailable(activeOptionsArray, variants, optionsDefs) {
      const names = optionsDefs.map(o => typeof o === 'string' ? o : o.name);

      const activeByName = {};
      names.forEach((name, idx) => { activeByName[name] = activeOptionsArray[idx] ?? null; });

      return variants.some(variant => {
        if (!variant.available) return false;

        const variantOptions = [variant.option1, variant.option2, variant.option3];

        return variantOptions.every((opt, idx) => {
          if (opt == null) return true;
          const name = names[idx];
          const selected = activeByName[name];
          return selected == null || selected === opt;
        });
      });
    }

    updateButtons(modal) {
      const script = modal.querySelector("script[data-product-variant-ids]");
      const scriptOptions = modal.querySelector("script[data-product-options-script]");
      const parsedOptions = JSON.parse(scriptOptions.innerText);
      const parsedVariants = JSON.parse(script.innerText);
      const activeOptions = parsedOptions.map(() => null);
      const activeButtons = modal.querySelectorAll("button[data-value-button].active");
    
      activeButtons.forEach((button, idx) => {
        const parent = button.closest("[data-option-container]");
        const label = parent.querySelector("[data-selected-value]").closest(".set-selector__option-head").querySelector("span");
        const name = label.innerText.trim().replace(":", "");
        const optIndex = parsedOptions.findIndex(o => o.name === name);
        if (optIndex >= 0) activeOptions[optIndex] = button.value;
      });
    
      parsedOptions.forEach((optDef, optIndex) => {
        const container = modal.querySelectorAll("[data-option-container]")[optIndex];
        const buttons = container.querySelectorAll("[data-value-button]");
    
        buttons.forEach(btn => {
          const testSelection = [...activeOptions];
          testSelection[optIndex] = btn.value;
          btn.disabled = !this.isCombinationAvailable(testSelection, parsedVariants, parsedOptions);
        });
      });
    }

    bindEvents() {
      const galleryScrollHandlers = new WeakMap();

      this.modalTriggers.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          this.activeSlot = index;
          const modalId = btn.dataset.modalId;
          this.openModal(modalId);
          this.loadAllProducts(modalId)
        });
      });

      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.closeModals());
      });

      this.addToCartButton?.addEventListener('click', () => {
        const modalButton = this.wrapper.querySelector(`button[data-modal-id]:not(.show-remove)`);
        if (modalButton) {
          modalButton.click();
        } else {
          this.addToCart();
        }
      });

      if (this.backdropEl) this.backdropEl.addEventListener("click", () => this.closeModals())

      document.addEventListener("click", (e) => {
        if (e.target.closest("button[data-item-button]")) {
          const productBtn = e.target.closest("button[data-item-button]");
          const title = productBtn.querySelector('[data-product-title]').innerText.trim();
          const imgSrc = productBtn.querySelector('[data-item-image]').getAttribute('src');
          const variantId = productBtn.dataset.variantId;
          const price = productBtn.dataset.productPrice;
          const priceValue = productBtn.dataset.productPriceValue;
          const selectedOptions = productBtn.dataset.selectedOptions;

          if (!productBtn.hasAttribute("data-free-product")) {
            this.totalPrice[this.activeSlot] = priceValue;
          } else {
            this.savePrice = +priceValue;
          }

          if (!variantId) {
            console.error('No variant id on selected product');
            return;
          }

          this.selectedProducts[this.activeSlot] = {
            title,
            imgSrc,
            variantId,
            price,
            selectedOptions
          };

          const slot = this.productPickers[this.activeSlot];

          slot.querySelector('[data-product-title]').innerText = title;
          slot.querySelector('[data-item-image]').setAttribute('src', imgSrc);
          slot.querySelector('[data-item-price]').innerText = price;
          slot.querySelector('[data-options]').innerText = selectedOptions;

          if (selectedOptions.includes("Default Title")) {
            slot.querySelector('[data-options]').innerText = "";
          }

          slot.classList.remove("empty");
          slot.classList.add("show-remove");

          this.updateUI();
          this.closeModals();
        }

        if (e.target.closest("[data-remove-product]")) {
          const target = e.target.closest("[data-remove-product]");
          const activeSlotId = target.getAttribute("data-slot-id");
          const slot = this.productPickers[+activeSlotId];
          const isFreeItem = +activeSlotId === 2;
          const emptyTitleText = isFreeItem ? `${window.locales.cat}` : `${window.locales.design} ${+activeSlotId + 1}`
          const imageSrc = isFreeItem ? window.placeHolderImage : "";

          slot.querySelector('[data-product-title]').innerText = emptyTitleText;
          slot.querySelector('[data-item-image]').setAttribute('src', imageSrc);
          slot.querySelector('[data-item-price]').innerText = formatMoney(3295, moneyFormat);
          slot.querySelector('[data-options]').innerText = "";
          slot.classList.remove("show-remove");

          if (!isFreeItem) slot.classList.add("empty");

          this.selectedProducts[+activeSlotId] = null;

          if (+activeSlotId <= 2) {
            this.totalPrice[+activeSlotId] = 0;
          } else {
            this.totalPrice[+activeSlotId] = formatMoney(3295, moneyFormat);
          }

          this.updateUI();
        }

        if (e.target.closest("[data-modal-close-size]")) {
          const target = e.target.closest("[data-modal-close-size]");
          const modalId = target.getAttribute("data-modal-close-size");
          const modal = target.closest(`[id='${modalId}']`);

          if (modal) modal.classList.remove("show");

          const slider = modal.querySelector(".set-selector__modal-slider");

          if (slider && galleryScrollHandlers.has(slider)) {
            const handler = galleryScrollHandlers.get(slider);

            slider.removeEventListener("scroll", handler);

            galleryScrollHandlers.delete(slider);
          }
        }

        if (e.target.closest("button[data-size-modal]")) {
          const target = e.target.closest("button[data-size-modal]");
          const modalId = target.getAttribute("data-size-modal");
          const modal = this.wrapper.querySelector(`[id='${modalId}']`);
          if (modal) {
            if (!modal.classList.contains("show")) modal.classList.add("show");

            const gallery = modal.querySelector(".set-selector__modal-gallery");
            const slider = gallery.querySelector(".set-selector__modal-slider");
            const handler = () => setGalleryScroll(gallery, slider);
            slider.addEventListener("scroll", handler);
            galleryScrollHandlers.set(slider, handler);
          }
        }

        if (e.target.closest("[data-value-button]:not(.active)")) {
          const target = e.target.closest("[data-value-button]");
          const parent = target.closest("[data-option-container]");
          const modal = target.closest("[data-modal-options]");

          if (parent) {
            parent.querySelectorAll("[data-value-button]").forEach(i => i.classList.remove("active"));
            const optionName = parent.querySelector("[data-selected-value]");
            optionName.innerText = target.value;
          }

          target.classList.add("active");
          this.updateButtons(modal);
        }

        if (e.target.closest("[data-submit-button]")) {
          const activeOptions = [];
          const target = e.target.closest("[data-submit-button]");
          const modal = target.closest("[data-modal-options]");
          const script = modal.querySelector("script[data-product-variant-ids]");
          const parsedVariants = JSON.parse(script.innerText);
          const activeButtons = modal.querySelectorAll("button[data-value-button].active");
          activeButtons.forEach(button => activeOptions.push(button.value));
          const currentVariant = this.getVariantBySelectedOptions(parsedVariants, activeOptions);
          const itemButton = modal.closest(".set-selector__item-wrapper")?.querySelector("button[data-item-button]");
          if (itemButton) {
            const prevVariantId = itemButton.getAttribute("data-variant-id");

            if (+prevVariantId !== currentVariant.id) {
              itemButton.setAttribute("data-variant-id", currentVariant.id);
              itemButton.setAttribute("data-selected-options", activeOptions.join(", "));
            }

            itemButton.click();
            modal.classList.remove("show");
          }
        }

        if (e.target.closest(".set-selector__slider-dot")) {
          const dot = e.target.closest(".set-selector__slider-dot");
          const gallery = dot.closest(".set-selector__modal-gallery");
          const dots = gallery.querySelectorAll(".set-selector__slider-dot");
          const slider = gallery.querySelector(".set-selector__modal-slider");
          const slides = slider.querySelectorAll("img");
          const index = [...dots].indexOf(dot);

          if (index >= 0) {
            slider.scrollTo({
              left: slides[index].offsetLeft,
              behavior: "smooth"
            });
          }
        }

        if (e.target.closest("[data-filter]")) {
          const target = e.target.closest("[data-filter]");
          const filterValue = target.getAttribute("data-filter");
          const buttons = target.parentNode.querySelectorAll(".active");
          const modal = target.closest("[data-modal]");
          const productsContainer = modal.querySelector("[data-load-more-target-container]")
          const items = productsContainer.querySelectorAll("[data-product-type]");

          if (target.classList.contains("active")) {
            target.classList.remove("active");
            items.forEach(item => item.parentNode.classList.remove("hidden"));
          } else {
            buttons.forEach(button => button.classList.remove("active"))
            target.classList.add("active");
            items.forEach(item => item.parentNode.classList.toggle("hidden", item.getAttribute("data-product-type") !== filterValue));
          }
        }
      });
    }

    getVariantBySelectedOptions(variants, options) {
      const filteredOptions = options.filter(opt => opt !== null && opt !== undefined && opt !== '');

      return variants.find(variant => {
        const variantOptions = [
          variant.option1,
          variant.option2,
          variant.option3
        ].filter(opt => opt !== null && opt !== undefined && opt !== '');

        if (variantOptions.length !== filteredOptions.length) {
          console.log('Options length mismatch:', variantOptions.length, 'vs', filteredOptions.length);
          return false;
        }

        const isMatch = variantOptions.every((opt, index) => opt === filteredOptions[index]);

        return isMatch;
      }) || null;
    }

    zIndexFix() {
      const productInfoEl = this.wrapper;

      if (productInfoEl) {
        if (this.openModals) {
          productInfoEl.style.zIndex = 10;
        } else {
          productInfoEl.style.zIndex = 1;
        }
      }
    }

    openModal(id) {
      this.closeModals();

      const modal = this.wrapper.querySelector(`[id='${id}']`);

      if (modal && !modal.classList.contains("show")) modal.classList.add('show');
      if (this.backdropEl && !this.backdropEl.classList.contains("show")) this.backdropEl.classList.add("show")
      if (!document.documentElement.classList.contains("lock")) document.documentElement.classList.add("lock");
      this.openModals = true;
      this.zIndexFix();
    }

    closeModals() {
      this.modals.forEach(modal => modal.classList.remove('show'));
      this.backdropEl.classList.remove("show")
      document.documentElement.classList.remove("lock");
      this.openModals = false;
      this.zIndexFix();
    }

    updateUI() {
      const count = this.selectedProducts.findIndex(p => p === null);

      if (this.designCountText) {
        this.designCountText.innerText = count + 1;
      }

      if (count === -1) {
        if (this.chooseDesign && !this.chooseDesign.classList.contains("hidden")) this.chooseDesign.classList.add("hidden");
        this.addToCartText?.classList.remove("hidden");
      } else {
        this.chooseDesign?.classList.remove("hidden");
        if (this.addToCartText && !this.addToCartText.classList.contains("hidden")) this.addToCartText.classList.add("hidden");
      }

      this.updatePrice(count !== -1, count);
    }

    updatePrice(showText, count) {
      const priceToShow = {
        finalPrice: "",
        oldPrice: "",
      };

      const mainPrice = window.mainProductPrice || 0;
      const totalPriceResult = this.totalPrice.reduce((a, c) => +a + +c) + mainPrice;
      const savePrice = formatMoney(this.savePrice, moneyFormat);

      priceToShow.finalPrice = formatMoney(totalPriceResult, moneyFormat);
      priceToShow.oldPrice = formatMoney(totalPriceResult + this.savePrice, moneyFormat);

      this.totalPriceEl.innerHTML = showText ? `${window.locales.chooseDesign} ${count + 1}` : `<span class="line-through text-subdued">${priceToShow.oldPrice}</span> ${priceToShow.finalPrice}`;
      this.savePriceEl.innerText = showText ? "---" : savePrice;
    }

    setLoading(set) {
      if (!this.addToCartText.classList.contains("hidden")) this.addToCartText.classList.add("hidden");

      const pillLoader = this.wrapper.querySelector(".set-selector [data-add-to-cart] pill-loader");

      if (pillLoader) {
        pillLoader.setAttribute("aria-busy", true);
        pillLoader.classList.remove("hidden");
      }

      if (!set) {
        this.addToCartText.classList.remove("hidden");
        if (pillLoader) {
          pillLoader.removeAttribute("aria-busy")
          if (!pillLoader.classList.contains("hidden")) pillLoader.classList.add("hidden");
        }
      }
    }

    cartUpdate() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      const drawer = document.querySelector("cart-drawer");

      if (drawer) {
        drawer.show();
      }
    }

    handleEditParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const editBundle = urlParams.get('edit_bundle');
      const bundleIds = urlParams.get('bundle_ids');
      
      if (editBundle && bundleIds) {
        this.editingBundle = {
          mainKey: urlParams.get('main_key'),
          bundleIds: bundleIds.split(',').filter(id => id),
          bundleKey: urlParams.get('bundle_key')
        };
        
        if (this.editingBundle.bundleIds.length > 0 && this.editingBundle.bundleKey) {
          this.preloadSelectedProducts();
        } else {
          console.error('Invalid edit bundle parameters');
          delete this.editingBundle;
        }
      }
    }
  
    async preloadSelectedProducts() {
      try {
        const cartRes = await fetch("/cart.json");
        const cartData = await cartRes.json();
        const cartItems = cartData.items;
        const bundleIds = this.editingBundle.bundleIds;
        
        for (let i = 0; i < bundleIds.length; i++) {
          const bundleId = bundleIds[i];
          const cartItem = cartItems.find(i => i.id === +bundleId);
          if (!cartItem) continue;
          const productResponse = await fetch(`/products/${cartItem.handle}.js`);
          const productData = await productResponse.json();
          const variant = productData.variants.find(variant => variant.id === +bundleId);
          
          this.selectedProducts[i] = {
            title: productData.title,
            imgSrc: cartItem.image|| '',
            variantId: variant.id,
            price: formatMoney(variant.price),
            selectedOptions: variant.options
          };

          if (i < 2) {
            this.totalPrice[i] = variant.price;
          } else {
            this.savePrice = variant.price;
          }

          const slot = this.productPickers[i];

          if (slot) {
            slot.querySelector('[data-product-title]').innerText = productData.title;
            slot.querySelector('[data-item-image]').setAttribute('src', cartItem.image|| '');
            slot.querySelector('[data-item-price]').innerText = formatMoney(variant.price);
            slot.querySelector('[data-options]').innerText = variant.options;
            
            slot.classList.remove("empty");
            slot.classList.add("show-remove");
          }

          this.updateUI()
        }
      } catch (error) {
        console.error('Error preloading products:', error);
      }
    }

    async addToCart() {
      this.setLoading(true);

      const items = [];

      if (this.editingBundle) {
        try {
          const cart = await fetch('/cart.js').then(res => res.json());
          const updates = {};
          
          cart.items.forEach(item => {
            if (item.properties?._bundle_key === this.editingBundle.bundleKey) {
              updates[item.key] = 0;
            }
          });
          
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          
        } catch (error) {
          console.error('Error removing old bundle:', error);
        }
      }

      const mainProductVariantId = window.mainProductVariantId;
      const bundleKey = this.editingBundle ? this.editingBundle.bundleKey : `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const bundleIdsStr = this.selectedProducts.map(p => p.variantId).join(',');
      
      for (let i = 0; i < this.selectedProducts.length; i++) {
        const p = this.selectedProducts[i];

        if (!p) continue;

        const item = {
          id: Number(p.variantId),
          quantity: 1,
          properties: {
            '_bundle_key': bundleKey,
            '_bundle_type': i === 2 ? 'free' : 'paid',
            '_bundle_index': i
          }
        };

        items.push(item);
      }

      items.push({
        id: Number(mainProductVariantId),
        quantity: 1,
        properties: {
          '_bundle_key': bundleKey,
          '_bundle_ids': bundleIdsStr,
          '_bundle_type': "main"
        }
      })
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: [...items] })
        });

        if (!response.ok) {
          const err = await response.json().catch(() => null);
          throw err || new Error('Error while adding item(response)');
        }
        
        this.setLoading(false);
        this.cartUpdate();

        if (this.editingBundle) {
          const url = new URL(window.location);
          url.searchParams.delete('edit_bundle');
          url.searchParams.delete('bundle_ids');
          url.searchParams.delete('main_key');
          url.searchParams.delete('bundle_key');
          window.history.replaceState({}, '', url);
          delete this.editingBundle;
        }
      } catch (err) {
        console.error('addToCart error', err);
        this.setLoading(false);

        throw err;
      }
    }

    createFilterButton(filter) {
      return `
        <button class="set-selector__row-item" data-filter="${filter}">
          ${this.renderIcon(filter)}
          <span class="set-selector__item-text text-sm">
            ${filter}
          </span>
        </button>
      `
    }

    renderIcon(filter) {
      switch (filter) {
        case "Almond":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C5.32456 1 5.74436 1.17337 6.24512 1.66602C6.73878 2.15178 7.2192 2.86154 7.64258 3.70117C8.49886 5.39942 9 7.37682 9 8.5293V16.3574C9 17.3369 8.58699 17.9304 7.91211 18.333C7.17135 18.7748 6.07195 19 4.77734 19C3.47946 18.9999 2.52045 18.7736 1.91211 18.3633C1.37303 17.9996 1 17.4198 1 16.3574V8.5293C1 7.37682 1.50114 5.39942 2.35742 3.70117C2.7808 2.86154 3.26122 2.15178 3.75488 1.66602C4.25565 1.17337 4.67546 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Round":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C7.03554 1 8.99985 3.08142 9 6.07617V15.7988C9 17.2297 8.54099 17.9356 7.96387 18.3379C7.31326 18.7914 6.31582 19 5 19C3.6842 19 2.68675 18.7914 2.03613 18.3379C1.459 17.9356 1 17.2297 1 15.7988V6.07617C1.00015 3.08143 2.9645 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Square":
          return `
            <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.30859 1C6.68716 1 7.54591 1.15419 8.08203 1.56445C8.55024 1.92276 8.99998 2.66932 9 4.51953V16.0273C9 17.8326 8.50654 18.7421 7.91602 19.2354C7.28865 19.7593 6.33515 20 5.04297 20C3.75155 20 2.77013 19.76 2.11816 19.2285C1.50762 18.7307 1 17.8205 1 16.0273V4.51953C1.00003 2.76708 1.54367 2.00862 2.16113 1.61035C2.87905 1.14745 3.9439 1 5.30859 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Around":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C7.03554 1 8.99985 3.08142 9 6.07617V15.7988C9 17.2297 8.54099 17.9356 7.96387 18.3379C7.31326 18.7914 6.31582 19 5 19C3.6842 19 2.68675 18.7914 2.03613 18.3379C1.459 17.9356 1 17.2297 1 15.7988V6.07617C1.00015 3.08143 2.9645 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Coffin":
          return `
            <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.12207 1L8.99902 15.4102C8.99022 17.4841 8.48071 18.5627 7.86914 19.1426C7.24392 19.7353 6.31125 20 5.04297 20C3.77477 20 2.81406 19.7355 2.16504 19.1348C1.5352 18.5517 1.00912 17.4736 1 15.4102L2.87793 1H7.12207Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `;
        case "Stiletto":
          return `
            <svg width="10" height="22" viewBox="0 0 10 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.03418 1.61035C5.30578 2.17048 5.58985 2.96293 5.87598 3.94727C6.44666 5.91062 6.9858 8.49782 7.45215 11.1865C8.38849 16.5851 8.99997 22.2128 9 23.7988C9 25.2297 8.54099 25.9356 7.96387 26.3379C7.31326 26.7914 6.31582 27 5 27C3.6842 27 2.68675 26.7914 2.03613 26.3379C1.459 25.9356 1 25.2297 1 23.7988C1.00003 22.2144 1.61132 16.7132 2.54785 11.376C3.01408 8.71904 3.55329 6.14503 4.125 4.15527C4.4116 3.15782 4.69822 2.33579 4.97559 1.7334C4.99521 1.69078 5.01506 1.64992 5.03418 1.61035Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        default:
          return ""
      }
    }

    createProductElement(product, collectionType) {
      let imagesHTML = '';
      let dotsHtml = '';
      const firstVariant = product.variants[0];
      const hasVariants = firstVariant.title !== "Default Title";
      const modalId = `modal-size-${collectionType}-${product.id}`;
      const isFree = collectionType === 'free';
      const images = product.images;
      
      images.forEach((image, index) => {
          imagesHTML += `<img src="${image.src}" alt="${image.alt || product.title}" width='${image.width}' height='${image.height}' loading="lazy">`;
          dotsHtml += `<span class="set-selector__slider-dot${index === 0 ? ' active' : ''}"></span>`
      });

      const options = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(i => i).join(", ")
      
      return `
        <div class="set-selector__item-wrapper">
          <button type="button"
            class="set-selector__item"
            data-item-button
            data-product-id="${product.id}"
            data-variant-id="${firstVariant.id}"
            data-product-price="${formatMoney(+firstVariant.price*100)}"
            data-product-price-value="${+firstVariant.price*100}"
            data-selected-options="${options || ''}"
            data-product-type="${product.product_type || ''}"
            ${isFree ? 'data-free-product' : ''}
          >
            <span class="set-selector__item-image">
              <img src="${images[0]?.src || ''}" alt="${product.title}" loading="lazy" data-item-image>
            </span>
            <span class="text-sm" data-product-title>
              ${product.title}
            </span>
            <span class="set-selector__item-price text-sm bold">${formatMoney(+firstVariant.price*100)}</span>
          </button>

          ${hasVariants ? `
            <button class="set-selector__item-size-button" type="button" data-size-modal="${modalId}"></button>
            ${this.createSizeModal(product, imagesHTML, dotsHtml, modalId)}
          ` : ''}
        </div>
      `;
    }

    createSizeModal(product, imagesHTML, dotsHtml, modalId) {
      const options = product.options || [];
      const variants = product.variants || [];
    
      function isValueAvailable(optionName, value, selectedValues) {
        return variants.some(variant => {
          if (!variant.available) return false;
          return options.every((opt, idx) => {
            const name = opt.name;
            let expected = selectedValues[name] ?? opt.values[0];
            if (name === optionName) expected = value;
            return variant[`option${idx + 1}`] === expected;
          });
        });
      }
    
      return `
        <div class="set-selector__modal" id="${modalId}" data-modal-options>
          <div class="set-selector__modal-head">
            <button type="button" data-modal-close-size="${modalId}">
              <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0.789092L1 6.80043L6 12.8118" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <p class="text-lg bold">
              ${window.locales?.quick_view || 'Quick View'}
            </p>
            <span><span></span></span>
          </div>
          <div class="set-selector__modal-body">
            <div class="set-selector__modal-gallery">
              <div class="set-selector__modal-slider">
                ${imagesHTML}
              </div>
              <div class="set-selector__slider-dots">
                ${dotsHtml}
              </div>
            </div>
            <p class="h4 bold">
              ${product.title}
            </p>
            <div class="set-selector__option-picker">
              ${options.map((option) => {
                const selectedValues = {};
                options.forEach(opt => {
                  selectedValues[opt.name] = opt.values[0];
                });
    
                return `
                  <div class="set-selector__option" data-option-container>
                    <div class="set-selector__option-head">
                      <span class="bold text-sm text-subdued">
                        ${option.name}:
                      </span>
                      <span class="text-sm" data-selected-value>
                        ${option.values[0]}
                      </span>
                    </div>
                    <div class="set-selector__option-row">
                      <div class="set-selector__option-values">
                       ${(() => {
                          let firstActiveSet = false;
                          return option.values.map((value) => {
                            const disabled = isValueAvailable(option.name, value, selectedValues) ? '' : 'disabled';
                            const active = !firstActiveSet && !disabled ? (() => { firstActiveSet = true; return ' active'; })() : '';
                            return `
                              <button class="set-selector__option-value button button--outline${active}"
                                type="button"
                                value="${value}"
                                data-value-button
                                ${disabled}>
                                ${value}
                              </button>
                            `;
                          }).join('');
                        })()}
                      </div>
                      ${option.name === "Size" ? `
                        <button class="size-chart-button text-sm text-subdued" 
                          aria-controls="size-chart-Set-selector"
                          aria-expanded="false">
                          ${window.locales?.find_size || 'Find Size'}
                        </button>
                      ` : ''}
                    </div>
                  </div>
                `;
              }).join('')}
            </div>
            <button type="button" class="set-selector__button-confirm button" data-submit-button>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9277 7.53662L0.11011 7.50171" stroke="currentColor"/>
                <path d="M7.53613 0.110107L7.50123 14.9277" stroke="currentColor"/>
              </svg>
              <span>
                ${window.locales?.choose || 'Choose'}
              </span>
            </button>
          </div>
          <script type="application/json" data-product-variant-ids>${JSON.stringify(variants)}</script>
          <script type="application/json" data-product-options-script>${JSON.stringify(options)}</script>
        </div>
      `;
    }
  }

  new SetSelector();
});